import { Divider } from "antd";

export default function ResponsiveDivider() {
    return (
        <>
            <Divider type='vertical' className='hidden h-4 border-gray-400 lg:inline-block' />
            <Divider className='lg:hidden border-gray-600 mb-3.5 mt-0' />
        </>
    )
}